// Keep in sync with $breakpoint-* in src/styles/_tokens.sass — sync-tokens
// covers colors but breakpoints live here and there in parallel for now.
export const Breakpoints = {
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1440,
};

export const BreakpointKeys = ['sm', 'md', 'lg', 'xl'];
